export const selectAllServices = state => state.service.services;

export const selectTariffsInfo = state => state.service.tariffsInfo;

export const selectCheckTariffsLoading = state =>
  state.service.isCheckTariffsLoading;

export const selectInactiveTariffDays = state =>
  state.service.inactiveTariffDays;
export const selectTariffsModalOpen = state => state.service.tariffsModalOpen;

export const selectParticularService = state => state.service.particularService;

export const selectLegalEntities = state => state.service.legalEntities;

// export const selectService = (state) => state.service.data;

export const selectLoading = state => state.service.isLoading;

export const selectError = state => state.service.error;

export const selectedServiceInSettingsId = state =>
  state.service.selectedServiceInSettingsId;
